import { coerceInteger } from "@serophin/shared";
import * as v from "valibot";

export const MIN_PAGE_LIMIT = 1;
export const MAX_PAGE_LIMIT = 100;
export const DEFAULT_PAGE_LIMIT = 20;

const pageLimit = v.pipe(v.union([v.number(), coerceInteger()]), v.integer(), v.minValue(MIN_PAGE_LIMIT), v.maxValue(MAX_PAGE_LIMIT));

/** `cursor` goes in and `nextCursor` comes out, as in spoola. A null `nextCursor` is the last page. */
export const pageRequest = {
  limit: v.optional(pageLimit),
  cursor: v.optional(v.pipe(v.string(), v.minLength(1), v.maxLength(1024))),
};

export const pageResponse = {
  nextCursor: v.nullable(v.string()),
};
